/*
  Moteur de particules WebGL du hero, sans dependance.

  Chaque calque porte deux formes (A et B) dans un seul tampon entrelace : le
  shader passe de l'une a l'autre selon uMorph, avec un retard propre a chaque
  particule. C'est ce qui fait naitre le motif a partir d'un nuage.

  Par-dessus la forme, le shader ajoute les mouvements permanents :
  - respiration : chaque point oscille un peu autour de sa place ;
  - drapeaux au vent : sous la ligne uSwayTop, ondulation croissante vers le bas ;
  - effilochage : une part des points du bas se detache, tombe et s'eteint ;
  - vague de lumiere : une bande eclaire le motif et l'avance vers le spectateur ;
  - montee : pour les braises, deplacement vertical en boucle.

  WebGL 1 et GLSL 100 volontairement : c'est ce qui tourne partout, y compris
  sur les telephones Android d'entree de gamme.
*/
(function (root) {
  'use strict';

  if (root.ZKParticles) return;

  var STRIDE = 16; // flottants par particule : A(3) B(3) couleurA(3) couleurB(3) aleas(4)

  /* ---------------------------------------------------------------------- */
  /* Matrices 4x4, ordre colonne                                             */
  /* ---------------------------------------------------------------------- */

  function mat() {
    var m = new Float32Array(16);
    m[0] = m[5] = m[10] = m[15] = 1;
    return m;
  }

  function mul(a, b) {
    var o = new Float32Array(16);
    for (var c = 0; c < 4; c++) {
      for (var r = 0; r < 4; r++) {
        o[c * 4 + r] =
          a[r] * b[c * 4] + a[4 + r] * b[c * 4 + 1] + a[8 + r] * b[c * 4 + 2] + a[12 + r] * b[c * 4 + 3];
      }
    }
    return o;
  }

  function perspective(fovy, aspect, near, far) {
    var f = 1 / Math.tan(fovy / 2);
    var nf = 1 / (near - far);
    var m = new Float32Array(16);
    m[0] = f / aspect;
    m[5] = f;
    m[10] = (far + near) * nf;
    m[11] = -1;
    m[14] = 2 * far * near * nf;
    return m;
  }

  function translation(x, y, z) {
    var m = mat();
    m[12] = x;
    m[13] = y;
    m[14] = z;
    return m;
  }

  function rotationX(a) {
    var m = mat(), c = Math.cos(a), s = Math.sin(a);
    m[5] = c; m[6] = s; m[9] = -s; m[10] = c;
    return m;
  }

  function rotationY(a) {
    var m = mat(), c = Math.cos(a), s = Math.sin(a);
    m[0] = c; m[2] = -s; m[8] = s; m[10] = c;
    return m;
  }

  function scaling(s) {
    var m = mat();
    m[0] = m[5] = m[10] = s;
    return m;
  }

  /* ---------------------------------------------------------------------- */
  /* Shaders                                                                 */
  /* ---------------------------------------------------------------------- */

  var VERT = [
    'precision highp float;',
    'attribute vec3 aA; attribute vec3 aB; attribute vec3 aCA; attribute vec3 aCB; attribute vec4 aR;',
    'uniform mat4 uProj; uniform mat4 uView; uniform mat4 uModel;',
    'uniform float uTime; uniform float uMorph; uniform float uDelaySpan; uniform float uSize; uniform float uPx;',
    'uniform float uAlpha; uniform float uNoise; uniform float uSwirl; uniform float uScatter; uniform float uTwinkle;',
    'uniform float uSway; uniform float uSwayTop; uniform float uDrip; uniform float uDripTop;',
    'uniform float uRise; uniform float uRiseRange;',
    'uniform float uScanY; uniform float uScanF; uniform float uScanPush; uniform vec3 uScanColor;',
    'varying vec3 vCol; varying float vA;',

    'float ease(float t) { return t < 0.5 ? 4.0 * t * t * t : 1.0 - pow(-2.0 * t + 2.0, 3.0) * 0.5; }',

    'void main() {',
    '  float m = ease(clamp((uMorph - aR.w * uDelaySpan) / (1.0 - uDelaySpan), 0.0, 1.0));',
    '  vec3 p = mix(aA, aB, m);',
    '  vec3 col = mix(aCA, aCB, m);',
    '  float alpha = 1.0;',

    // Drapeaux au vent : rien au-dessus de uSwayTop, de plus en plus fort dessous.
    '  float sw = clamp((uSwayTop - p.y) / 2.2, 0.0, 1.0);',
    '  sw *= sw * uSway;',
    '  p.x += sin(uTime * 1.25 + p.y * 2.3 + p.x * 0.7) * sw;',
    '  p.z += cos(uTime * 1.05 + p.y * 1.9) * sw * 0.8;',

    '  float ph = aR.z * 6.2831853;',
    '  vec3 dir = normalize(vec3(sin(ph * 1.7 + aR.x * 9.0), cos(ph * 1.3 + aR.y * 7.0), sin(ph + aR.x * 5.0)) + vec3(0.0001));',

    // Pendant la transition : tourbillon autour de l axe vertical, et une
    // poussee vers l exterieur qui retombe a l arrivee.
    '  float mid = sin(m * 3.14159265);',
    '  float ang = mid * uSwirl * (0.6 + aR.x);',
    '  float cs = cos(ang); float sn = sin(ang);',
    '  p.xz = mat2(cs, -sn, sn, cs) * p.xz;',
    '  p += dir * mid * uSwirl * 0.35 * (0.4 + aR.y);',

    '  float t = uTime * 0.55 + ph;',
    '  p += vec3(sin(t + p.y * 1.9), cos(t * 0.83 + p.x * 1.4), sin(t * 1.13 + p.x + p.y)) * uNoise * (0.35 + aR.y * 0.9);',

    // Effilochage : les points tires au sort sous uDripTop tombent puis s eteignent.
    '  if (aR.x < uDrip && p.y < uDripTop) {',
    '    float d = fract(uTime * 0.08 + aR.z * 7.0);',
    '    p.y -= d * d * 1.6;',
    '    p.x += sin(d * 5.0 + aR.y * 6.2831853) * 0.07 * d;',
    '    alpha *= 1.0 - d;',
    '  }',

    '  p += dir * uScatter * (0.4 + aR.x * 1.8);',

    '  if (uRiseRange > 0.0) {',
    '    float h = uRiseRange * 0.5;',
    '    p.y = mod(p.y + uTime * uRise * (0.5 + aR.y) + h, uRiseRange) - h;',
    '    alpha *= smoothstep(-h, -h + 0.8, p.y) * (1.0 - smoothstep(h - 1.4, h, p.y));',
    '  }',

    '  float scan = exp(-pow((p.y - uScanY) * 6.0, 2.0)) * uScanF;',
    '  p.z += scan * uScanPush;',

    '  vec4 mv = uView * uModel * vec4(p, 1.0);',
    '  gl_Position = uProj * mv;',
    '  float depth = max(-mv.z, 0.05);',
    '  float tw = mix(1.0, 0.4 + 0.6 * (0.5 + 0.5 * sin(uTime * (1.2 + aR.y * 3.0) + aR.z * 40.0)), uTwinkle);',
    '  gl_PointSize = clamp(uSize * (0.45 + aR.y * 0.9) * uPx / depth * (1.0 + scan * 0.6), 1.0, 48.0);',
    '  vCol = col + scan * uScanColor;',
    '  vA = uAlpha * tw * alpha;',
    '}'
  ].join('\n');

  var FRAG = [
    'precision mediump float;',
    'varying vec3 vCol; varying float vA;',
    'uniform float uSoft;',
    'void main() {',
    '  vec2 c = gl_PointCoord - 0.5;',
    '  float r = dot(c, c) * 4.0;',
    '  if (r > 1.0) discard;',
    '  float a = pow(1.0 - r, uSoft) * vA;',
    '  gl_FragColor = vec4(vCol * a, a);',
    '}'
  ].join('\n');

  var UNIFORMS = [
    'uProj', 'uView', 'uModel', 'uTime', 'uMorph', 'uDelaySpan', 'uSize', 'uPx', 'uAlpha', 'uNoise',
    'uSwirl', 'uScatter', 'uTwinkle', 'uSway', 'uSwayTop', 'uDrip', 'uDripTop', 'uRise', 'uRiseRange',
    'uScanY', 'uScanF', 'uScanPush', 'uScanColor', 'uSoft'
  ];

  function compile(gl, type, src) {
    var sh = gl.createShader(type);
    gl.shaderSource(sh, src);
    gl.compileShader(sh);
    if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(sh));
    return sh;
  }

  /* ---------------------------------------------------------------------- */
  /* Aleatoire reproductible                                                 */
  /* ---------------------------------------------------------------------- */

  function rng(seed) {
    var a = (seed || 1) >>> 0;
    return function () {
      a |= 0;
      a = (a + 0x6d2b79f5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  /* ---------------------------------------------------------------------- */
  /* Formes                                                                  */
  /* ---------------------------------------------------------------------- */

  function Shape(n) {
    this.n = n;
    this.pos = new Float32Array(n * 3);
    this.col = new Float32Array(n * 3);
  }

  Shape.prototype.set = function (i, x, y, z, r, g, b) {
    var k = i * 3;
    this.pos[k] = x; this.pos[k + 1] = y; this.pos[k + 2] = z;
    this.col[k] = r; this.col[k + 1] = g; this.col[k + 2] = b;
  };

  // Melange les indices : le halo n'est trace que sur le debut du tampon, il
  // doit donc tomber sur des points repartis partout.
  function shuffle(s, seed) {
    var rand = rng(seed || 7);
    for (var i = s.n - 1; i > 0; i--) {
      var j = Math.floor(rand() * (i + 1));
      for (var c = 0; c < 3; c++) {
        var a = i * 3 + c, b = j * 3 + c, t = s.pos[a];
        s.pos[a] = s.pos[b]; s.pos[b] = t;
        t = s.col[a]; s.col[a] = s.col[b]; s.col[b] = t;
      }
    }
    return s;
  }

  function concat(list, seed) {
    var n = 0, i;
    for (i = 0; i < list.length; i++) n += list[i].n;
    var out = new Shape(n), o = 0;
    for (i = 0; i < list.length; i++) {
      out.pos.set(list[i].pos, o * 3);
      out.col.set(list[i].col, o * 3);
      o += list[i].n;
    }
    return shuffle(out, seed);
  }

  function loadPixels(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        var c = document.createElement('canvas');
        c.width = img.naturalWidth;
        c.height = img.naturalHeight;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(img, 0, 0);
        try {
          resolve({ w: c.width, h: c.height, d: x.getImageData(0, 0, c.width, c.height).data });
        } catch (error) {
          reject(error);
        }
      };
      img.onerror = reject;
      img.src = src;
    });
  }

  // Echantillonne n points dans une image, avec une probabilite donnee par
  // opts.weight. opts.place recoit (u, v, r, g, b, a, rand, out) et remplit
  // out = [x, y, z, r, g, b]. u et v vont de 0 a 1, v vers le bas.
  function fromPixels(px, n, opts, seed) {
    var W = px.w, H = px.h, d = px.d, P = W * H;
    var cdf = new Float32Array(P), acc = 0, i, k;
    for (i = 0; i < P; i++) {
      k = i * 4;
      acc += Math.max(0, opts.weight(d[k] / 255, d[k + 1] / 255, d[k + 2] / 255, d[k + 3] / 255,
        ((i % W) + 0.5) / W, (Math.floor(i / W) + 0.5) / H));
      cdf[i] = acc;
    }
    var s = new Shape(n), rand = rng(seed || 1), out = [0, 0, 0, 0, 0, 0];
    for (var j = 0; j < n; j++) {
      var t = rand() * acc, lo = 0, hi = P - 1;
      while (lo < hi) {
        var mid = (lo + hi) >> 1;
        if (cdf[mid] < t) lo = mid + 1; else hi = mid;
      }
      k = lo * 4;
      var u = ((lo % W) + rand()) / W, v = (Math.floor(lo / W) + rand()) / H;
      opts.place(u, v, d[k] / 255, d[k + 1] / 255, d[k + 2] / 255, d[k + 3] / 255, rand, out);
      s.set(j, out[0], out[1], out[2], out[3], out[4], out[5]);
    }
    return s;
  }

  // Nuage spherique : l'etat de depart, avant que le motif ne se forme.
  function nebula(n, radius, seed, palette) {
    var s = new Shape(n), rand = rng(seed || 17);
    palette = palette || [[0.9, 0.9, 0.95], [0.89, 0.1, 0.12], [0.5, 0.55, 0.7]];
    for (var i = 0; i < n; i++) {
      var u = rand() * 2 - 1, a = rand() * Math.PI * 2, rr = radius * (0.35 + Math.pow(rand(), 0.6) * 0.9);
      var q = Math.sqrt(1 - u * u), c = palette[Math.floor(rand() * palette.length)], dim = 0.35 + rand() * 0.5;
      s.set(i, q * Math.cos(a) * rr * 1.6, u * rr, q * Math.sin(a) * rr, c[0] * dim, c[1] * dim, c[2] * dim);
    }
    return s;
  }

  // Poussiere d'etoiles lointaine.
  function dust(n, spread, seed) {
    var s = new Shape(n), rand = rng(seed || 23);
    for (var i = 0; i < n; i++) {
      var dim = 0.15 + Math.pow(rand(), 3) * 0.7, warm = rand() < 0.12;
      s.set(i, (rand() - 0.5) * spread * 1.8, (rand() - 0.5) * spread, -2 - rand() * spread,
        warm ? dim : dim * 0.85, warm ? dim * 0.25 : dim * 0.9, warm ? dim * 0.25 : dim);
    }
    return s;
  }

  // Braises : points chauds repartis dans une boite, que le shader fait monter.
  function embers(n, width, height, seed) {
    var s = new Shape(n), rand = rng(seed || 37);
    var palette = [[1, 0.18, 0.12], [1, 0.45, 0.16], [1, 0.82, 0.6], [0.95, 0.06, 0.1]];
    for (var i = 0; i < n; i++) {
      var c = palette[Math.floor(rand() * palette.length)], dim = 0.45 + rand() * 0.55;
      s.set(i, (rand() - 0.5) * width, (rand() - 0.5) * height, -2.6 + rand() * 3.4, c[0] * dim, c[1] * dim, c[2] * dim);
    }
    return s;
  }

  /* ---------------------------------------------------------------------- */
  /* Calque                                                                  */
  /* ---------------------------------------------------------------------- */

  var DEFAULTS = {
    morph: 1, delaySpan: 0.45, size: 0.02, alpha: 1, noise: 0.01, swirl: 0, scatter: 0, twinkle: 0.25,
    sway: 0, swayTop: 99, drip: 0, dripTop: -99, rise: 0, riseRange: 0,
    scanY: -99, scanF: 0, scanPush: 0, scanColor: [0, 0, 0], soft: 1.6
  };

  function Layer(engine, n, opts) {
    opts = opts || {};
    this.engine = engine;
    this.n = n;
    this.u = {};
    for (var key in DEFAULTS) this.u[key] = DEFAULTS[key];
    for (key in opts.uniforms || {}) this.u[key] = opts.uniforms[key];
    // Halo : second trace d'une partie des points, gros et tres transparents,
    // qui fait office de bloom sans passe de post-traitement.
    // [multiplicateur de taille, multiplicateur d'opacite, part des points].
    this.halo = opts.halo || null;
    this.position = [0, 0, 0];
    this.rotation = [0, 0, 0];
    this.scale = 1;
    this.data = new Float32Array(n * STRIDE);
    this.anim = null;
    var rand = rng(opts.seed || 29);
    for (var i = 0; i < n; i++) {
      var o = i * STRIDE + 12;
      this.data[o] = rand();
      this.data[o + 1] = rand();
      this.data[o + 2] = rand();
      this.data[o + 3] = rand();
    }
    var gl = engine.gl;
    this.buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
    gl.bufferData(gl.ARRAY_BUFFER, this.data, gl.DYNAMIC_DRAW);
    this.dirty = false;
  }

  // slot 0 = forme A, slot 1 = forme B.
  Layer.prototype.write = function (slot, shape) {
    var off = slot ? 3 : 0, coff = slot ? 9 : 6, d = this.data;
    for (var i = 0; i < this.n; i++) {
      var o = i * STRIDE, k = i * 3;
      d[o + off] = shape.pos[k]; d[o + off + 1] = shape.pos[k + 1]; d[o + off + 2] = shape.pos[k + 2];
      d[o + coff] = shape.col[k]; d[o + coff + 1] = shape.col[k + 1]; d[o + coff + 2] = shape.col[k + 2];
    }
    this.dirty = true;
  };

  // Ordre d'arrivee des particules : fn(x, y, z, alea) -> 0..1.
  Layer.prototype.order = function (fn) {
    var d = this.data;
    for (var i = 0; i < this.n; i++) {
      var o = i * STRIDE;
      d[o + 15] = Math.min(1, Math.max(0, fn(d[o + 3], d[o + 4], d[o + 5], d[o + 12])));
    }
    this.dirty = true;
  };

  Layer.prototype.show = function (shape) {
    this.write(0, shape);
    this.write(1, shape);
    this.u.morph = 1;
    this.current = shape;
    this.anim = null;
  };

  // Transition vers une nouvelle forme. La forme courante devient A.
  Layer.prototype.morphTo = function (shape, duration, opts) {
    opts = opts || {};
    if (this.current) this.write(0, this.current);
    this.write(1, shape);
    if (opts.order) this.order(opts.order);
    this.current = shape;
    this.u.morph = 0;
    this.anim = { start: this.engine.time, duration: duration || 2, done: opts.done };
  };

  Layer.prototype.matrix = function () {
    var p = this.position, r = this.rotation;
    return mul(translation(p[0], p[1], p[2]), mul(rotationY(r[1]), mul(rotationX(r[0]), scaling(this.scale))));
  };

  /* ---------------------------------------------------------------------- */
  /* Moteur                                                                  */
  /* ---------------------------------------------------------------------- */

  function Engine(canvas, opts) {
    opts = opts || {};
    var gl = canvas.getContext('webgl', {
      alpha: true, antialias: false, depth: false, premultipliedAlpha: true,
      powerPreference: 'high-performance'
    });
    if (!gl) throw new Error('WebGL indisponible');
    this.gl = gl;
    this.canvas = canvas;
    this.layers = [];
    this.time = 0;
    this.camera = { z: 6, fov: (34 * Math.PI) / 180, yaw: 0, pitch: 0, x: 0, y: 0 };
    this.maxDpr = opts.maxDpr || 1.75;
    this.halos = opts.halos !== false;
    this.onFrame = null;
    this.running = false;
    this.frameTimes = [];

    var prog = gl.createProgram();
    gl.attachShader(prog, compile(gl, gl.VERTEX_SHADER, VERT));
    gl.attachShader(prog, compile(gl, gl.FRAGMENT_SHADER, FRAG));
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(prog));
    gl.useProgram(prog);
    this.loc = {};
    for (var i = 0; i < UNIFORMS.length; i++) this.loc[UNIFORMS[i]] = gl.getUniformLocation(prog, UNIFORMS[i]);
    this.attr = {
      aA: gl.getAttribLocation(prog, 'aA'), aB: gl.getAttribLocation(prog, 'aB'),
      aCA: gl.getAttribLocation(prog, 'aCA'), aCB: gl.getAttribLocation(prog, 'aCB'),
      aR: gl.getAttribLocation(prog, 'aR')
    };
    for (var a in this.attr) gl.enableVertexAttribArray(this.attr[a]);
    gl.disable(gl.DEPTH_TEST);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE);
    gl.clearColor(0, 0, 0, 0);

    var self = this;
    this._loop = function (now) { self.frame(now); };
    this.resize();
  }

  Engine.prototype.add = function (n, opts) {
    var l = new Layer(this, n, opts);
    this.layers.push(l);
    return l;
  };

  Engine.prototype.resize = function () {
    var dpr = Math.min(window.devicePixelRatio || 1, this.maxDpr);
    var w = this.canvas.clientWidth, h = this.canvas.clientHeight;
    this.canvas.width = Math.max(1, Math.round(w * dpr));
    this.canvas.height = Math.max(1, Math.round(h * dpr));
    this.width = Math.max(1, w);
    this.height = Math.max(1, h);
    this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
  };

  Engine.prototype.start = function () {
    if (this.running) return;
    this.running = true;
    this.last = performance.now();
    requestAnimationFrame(this._loop);
  };

  Engine.prototype.stop = function () {
    this.running = false;
  };

  // Duree moyenne d'une image sur les dernieres mesures, en secondes.
  Engine.prototype.averageFrame = function () {
    var f = this.frameTimes;
    if (f.length < 30) return 0;
    var sum = 0;
    for (var i = 0; i < f.length; i++) sum += f[i];
    return sum / f.length;
  };

  Engine.prototype.frame = function (now) {
    if (!this.running) return;
    var raw = (now - this.last) / 1000;
    var dt = Math.min(0.05, raw);
    this.last = now;
    this.time += dt;
    this.frameTimes.push(raw);
    if (this.frameTimes.length > 90) this.frameTimes.shift();

    if (this.onFrame) this.onFrame(this.time, dt);
    this.tick();
    this.draw();
    requestAnimationFrame(this._loop);
  };

  // Avance les transitions en cours.
  Engine.prototype.tick = function () {
    for (var i = 0; i < this.layers.length; i++) {
      var l = this.layers[i];
      if (!l.anim) continue;
      var t = (this.time - l.anim.start) / l.anim.duration;
      l.u.morph = Math.min(1, t);
      if (t >= 1) {
        var done = l.anim.done;
        l.anim = null;
        if (done) done();
      }
    }
  };

  Engine.prototype.draw = function () {
    var gl = this.gl, c = this.camera, L = this.loc;
    gl.clear(gl.COLOR_BUFFER_BIT);
    var proj = perspective(c.fov, this.width / this.height, 0.1, 100);
    var view = mul(translation(-c.x, -c.y, -c.z), mul(rotationX(c.pitch), rotationY(c.yaw)));
    gl.uniformMatrix4fv(L.uProj, false, proj);
    gl.uniformMatrix4fv(L.uView, false, view);
    gl.uniform1f(L.uTime, this.time);
    gl.uniform1f(L.uPx, this.canvas.height / 2 / Math.tan(c.fov / 2));
    var A = this.attr, bytes = STRIDE * 4;

    for (var i = 0; i < this.layers.length; i++) {
      var l = this.layers[i], u = l.u;
      if (u.alpha <= 0.001) continue;
      gl.bindBuffer(gl.ARRAY_BUFFER, l.buffer);
      if (l.dirty) {
        gl.bufferSubData(gl.ARRAY_BUFFER, 0, l.data);
        l.dirty = false;
      }
      gl.vertexAttribPointer(A.aA, 3, gl.FLOAT, false, bytes, 0);
      gl.vertexAttribPointer(A.aB, 3, gl.FLOAT, false, bytes, 12);
      gl.vertexAttribPointer(A.aCA, 3, gl.FLOAT, false, bytes, 24);
      gl.vertexAttribPointer(A.aCB, 3, gl.FLOAT, false, bytes, 36);
      gl.vertexAttribPointer(A.aR, 4, gl.FLOAT, false, bytes, 48);

      gl.uniformMatrix4fv(L.uModel, false, l.matrix());
      gl.uniform1f(L.uMorph, u.morph);
      gl.uniform1f(L.uDelaySpan, u.delaySpan);
      gl.uniform1f(L.uSize, u.size);
      gl.uniform1f(L.uAlpha, u.alpha);
      gl.uniform1f(L.uNoise, u.noise);
      gl.uniform1f(L.uSwirl, u.swirl);
      gl.uniform1f(L.uScatter, u.scatter);
      gl.uniform1f(L.uTwinkle, u.twinkle);
      gl.uniform1f(L.uSway, u.sway);
      gl.uniform1f(L.uSwayTop, u.swayTop);
      gl.uniform1f(L.uDrip, u.drip);
      gl.uniform1f(L.uDripTop, u.dripTop);
      gl.uniform1f(L.uRise, u.rise);
      gl.uniform1f(L.uRiseRange, u.riseRange);
      gl.uniform1f(L.uScanY, u.scanY);
      gl.uniform1f(L.uScanF, u.scanF);
      gl.uniform1f(L.uScanPush, u.scanPush);
      gl.uniform3f(L.uScanColor, u.scanColor[0], u.scanColor[1], u.scanColor[2]);
      gl.uniform1f(L.uSoft, u.soft);
      gl.drawArrays(gl.POINTS, 0, l.n);

      if (l.halo && this.halos) {
        gl.uniform1f(L.uSize, u.size * l.halo[0]);
        gl.uniform1f(L.uAlpha, u.alpha * l.halo[1]);
        gl.uniform1f(L.uSoft, 2.2);
        gl.uniform1f(L.uTwinkle, 0);
        gl.uniform1f(L.uScanF, 0);
        gl.drawArrays(gl.POINTS, 0, Math.floor(l.n * l.halo[2]));
      }
    }
  };

  Engine.prototype.destroy = function () {
    this.stop();
    for (var i = 0; i < this.layers.length; i++) this.gl.deleteBuffer(this.layers[i].buffer);
    this.layers = [];
    var lose = this.gl.getExtension('WEBGL_lose_context');
    if (lose) lose.loseContext();
  };

  root.ZKParticles = {
    Engine: Engine,
    Shape: Shape,
    rng: rng,
    concat: concat,
    shuffle: shuffle,
    loadPixels: loadPixels,
    fromPixels: fromPixels,
    nebula: nebula,
    dust: dust,
    embers: embers
  };
})(window);
